export default __webpack_public_path__ + "static/media/icon-eye-open.54865942.webp";